import { Navigate } from "react-router-dom";

//pages

//login
import Login from "../pages/Authentication/Login";
import Register from "../pages/Authentication/Register";
import Logout from "../pages/Authentication/Logout";
import UsersList from "pages/User";
import Error404 from "pages/Error/Error404";
import EditUser from "pages/User/Edit";
import CreateUser from "pages/User/Create";
import TaskMilestone from "pages/Task";
import Collaborations from "pages/Collaboration";
import Dashboard from "pages/Dashboard";
import Creators from "pages/Creators";
import Campaigns from "pages/Campaign";
import CampaignDetail from "pages/Campaign/Detail";
import Applications from "pages/Application";
import CollaborationChat from "pages/Task/Chat";

// Landing Index

// User Profile

const authProtectedRoutes = [
 
  // { path: "/collaboration", component: <h6>Collaboration</h6> },
  { path: "/", component: <Dashboard /> },
  { path: "/dashbaord", component: <Dashboard /> },
  { path: "/user", component: <UsersList /> },
  { path: "/user/create", component: <CreateUser /> },
  { path: "/user/:userId", component: <EditUser /> },
  { path: "/tasks", component: <TaskMilestone /> },
  { path: "/tasks/:campaignId/collaboration/:collaborationId/milestone/:milestoneId", component: <TaskMilestone /> },
  { path: "/tasks/:campaignId/collaboration/:collaborationId", component: <TaskMilestone /> },
  { path: "/collaborations", component: <Collaborations /> },
  { path: "/creators", component: <Creators /> },
  { path: "/campaign", component: <Campaigns /> },
  { path: "/campaign/:campaignId", component: <CampaignDetail /> },
  { path: "/application", component: <Applications /> },
  { path: '/chat', exact: true, component: <CollaborationChat /> },
  { path: '/chat/:uuid', exact: true, component: <CollaborationChat /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  // {
  //   path: "/",
  //   exact: true,
  //   component: <Navigate to="/" />,
  // },
  { path: "*", component: <Error404 /> },  
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/register", component: <Register /> },


];

export { authProtectedRoutes, publicRoutes };